import React from 'react';
import {FormDialog} from 'components/core';
import {TemplatesCtx} from 'components/dataProviders/procedureTemplates';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dialog:
  {
    width: 700
  }
}), {name: "EditTemplateDialog"});

export default function EditTemplateDialog({open, onClose=()=>{}, onConfirm=()=>{}, templateID = null})
{
    const classes = useStyles();
    const [loading, setLoading] = React.useState(false);
    const ctx = React.useContext(TemplatesCtx);
    const editMode = templateID !== null;
    
    const template = ctx.data.indexed[templateID];


    const handleConfirm = (values) => {
      setLoading(true);
      if(editMode)
      {
        ctx.funcs.update(templateID, values).then(() => {
          setLoading(false);
          onConfirm();
        });
      }
      else
      {
        ctx.funcs.create(values).then(() => {
          setLoading(false);
          onConfirm();
        });
      }
    }


    //if(!template) return null;

    return <FormDialog
      open={open}
      onClose={()=>onClose()}
      onConfirm={handleConfirm}
      title= {editMode ? "Editar plantilla" : "Crear nueva plantilla"}
      subtitle="Añade un nombre y una descripción para tu plantilla"
      confirm="Siguiente"
      cancel="Cancelar"
      loading={loading}
      className={classes.dialog}
      fields={[
        {
          type: "text",
          label: "Nombre",
          id: "name",
          placeholder: "Nombre de la plantilla",
          mandatory: true,
          value: editMode ? template.name : ""
        },
        {
          type: "textarea",
          label: "Descripción",
          id: "description",
          placeholder: "",
          mandatory: false,
          value: editMode ? template.description : ""
        }
      ]}
      />
}
